import { formatDatacalogIntoOption } from "helpers/datacatalog.helper";
import { formatGlobalProductIntoOption } from "helpers/global-product.helper";
import { memo } from "react";
import { ExpandableSection } from "routes/skus/components/expandable-section";
import { IItemNumber } from "types/data.interface";
import GlobalProduct from "../../../mpn/components/attributes-modal/GlobalProductTemplate";
import GPCValuesImportTable from "../../../mpn/components/tcc-values-import/GPCValuesImportTable";

const ItemNumberViewHierarchy = memo(
  ({ itemNumberData }: { itemNumberData: IItemNumber }) => {

    return (
      <>
        <div className="row">
          <div className="col-12 p-0">
            <label className="form-label">Item Number</label>
            <textarea
              value={
                !!itemNumberData?.itn_itemno
                  ? itemNumberData?.itn_itemno + " - " + itemNumberData?.name
                  : formatGlobalProductIntoOption(
                      itemNumberData?.global_product,
                    )?.label.split(" -")[0] +
                    "-" +
                    itemNumberData?.suffix +
                    " - " +
                    itemNumberData?.name
                // itemNumberData.itn_itemno + " - " + itemNumberData?.name
              }
              disabled={true}
              rows={1}
              className="form-control d-inline no-resize horizontal-scroll"
            />
          </div>
        </div>

        <ExpandableSection
          title="Global Product Attributes"
          sectionId="120"
          expandedByDefault={true}
          className="mb-2"
        >
          <div>
            <div className="col-auto">
              <label className="form-label">Global Product</label>
              <textarea
                value={
                  formatGlobalProductIntoOption(itemNumberData?.global_product)
                    .label
                }
                disabled={true}
                rows={1}
                className="form-control d-inline no-resize horizontal-scroll"
              />
            </div>
          </div>

          <div className="row">
            <div className="col-4">
              <label className="form-label">Category</label>
              <textarea
                value={
                  itemNumberData?.global_product?.sub_category?.parent
                    ? formatDatacalogIntoOption(
                        itemNumberData?.global_product?.sub_category?.parent,
                      ).label
                    : ""
                }
                disabled={true}
                rows={1}
                className="form-control d-inline no-resize horizontal-scroll"
              />
            </div>
            <div className="col-4">
              <label className="form-label">Sub-Category</label>
              <textarea
                value={
                  formatDatacalogIntoOption(
                    itemNumberData?.global_product?.sub_category,
                  ).label
                }
                disabled={true}
                rows={1}
                className="form-control d-inline no-resize horizontal-scroll"
              />
            </div>
            <div className="col-4">
              <label className="form-label">Product Line</label>
              <textarea
                value={
                  formatDatacalogIntoOption(
                    itemNumberData?.global_product?.product_line,
                  ).label
                }
                disabled={true}
                rows={1}
                className="form-control d-inline no-resize horizontal-scroll"
              />
            </div>
          </div>
          <GlobalProduct model={itemNumberData?.global_product} />

          <ExpandableSection
            title="Global Product Composition"
            sectionId="gp-composition"
            expandedByDefault={false}
            className="mb-2"
          >
             <GPCValuesImportTable
                  isInApprovalProcess={true}
                  isRevision={false}
                  isViewOnly={true}
                  //@ts-ignore
                  composition={itemNumberData.global_product?.gpc_composition}

                />
          </ExpandableSection>
        </ExpandableSection>
      </>
    );
  },
);

export default ItemNumberViewHierarchy;
